<script>
  import { _ } from 'svelte-i18n'
  import Card from '/Atoms/Card'
  import Link from '/Atoms/Link'

  export let data

  /*
  const example = [{
    name: "Tega Brain",
    slug: "tega_brain",
  }]*/

  const artists = data

</script>

<Card flow>
  <h5 class="header">
    {$_("widgets.artists.title")}
  </h5>
  <ul class="artists">
    {#each artists as artist}
    <li class="artist">
      <Link section="artwork" slug={artist.slug} hover="none">
        <span class="pill">
          {artist.name}
        </span>
      </Link>
    </li>
    {/each}
  </ul>
</Card>

<style lang="scss">
  .header {
    @include typo-serif-title-32;
    text-align: center;

    margin-bottom: 33px;
    @include media-small {
      margin-bottom: 24px;
    }
  }

  .artists {
    display: block;
  }

  .artist {
    float:left;
    margin: 0 10px 18px 0;
    @include media-small {
      margin: 0 10px 10px 0;
    }
  }

  .pill {
    display: flex;
    flex-direction: row;
    align-items: center;
    @include typo-serif-text-28;

    background-color: $color-gray6;
    box-shadow: $shadow;
    &:hover {
      box-shadow: $link-hover-shadow;
    }
    
    border-radius: 20px;

    padding: 14px 20px;
    @include media-small {
      padding: 10px 15px;
    }
  }

</style>